/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type OverrideInAction = typeof OverrideInAction[keyof typeof OverrideInAction];


export const OverrideInAction = {
  record: 'record',
  skip: 'skip',
} as const;
